/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import {alert} from 'util/alert'
import './Modal.scss';
import locale from './locale'
import Name from 'components/UI/Form/Fields/Name'
import Gender from 'components/UI/Form/Fields/Gender'
import DOBPicker from 'components/UI/DOBPicker'
import Tags from 'components/UI/Form/Fields/Tags/index'
import Input from 'components/UI/Form/Fields/Input'
import Remarks from 'components/UI/Form/Fields/Remarks'
import ReactPhoneInput from 'components/Form/Fields/PhoneNumber'
import moment from 'moment'
import getClientDetail from 'controllers/client/getClientDetail'
import getClientCustomFields from 'controllers/client/getClientCustomFields';
import CheckboxForCustomField from 'components/UI/CustomField/CheckboxForCustomField';
import Form from 'components/Form';

const DEFAULT_REGION_CODE = 'ca';
class ModalContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      suggestions: [],
      clientInfo: {
        first_name: '',
        last_name: '',
        gender: 'male',
        date_of_birth: '',
        // mobile: '1',
        mobile_parsed: {country_code: "1", national_number: "", region_code: DEFAULT_REGION_CODE},
        email: '',
        guardian_name: '',
        guardian_mobile: '',
        guardian_email: '',
        remark: '',
        tag_name_list: [],
      },
      showHint: false,
      testNo: '',
      customFieldSchema: [],
    }

    this.onChange = this.onChange.bind(this)
    this.onNameChange = this.onNameChange.bind(this)
    this.onMobileChange = this.onMobileChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleAddition = this.handleAddition.bind(this)
    this.handleInputFocus = this.handleInputFocus.bind(this)

  }

  componentWillMount(){
    this.loadCustomFieldSchema();    

    if(this.props.clientId){
      getClientDetail(this.props.clientId)
      .then((res) => {
        let convertedGender = '';
        if (res.gender == 0){
          convertedGender = 'male'
        } else if (res.gender == 1){
          convertedGender = 'female'
        }else {
          convertedGender = 'n/a'
        }

        let convertedTag = []
        if(res.tag_name_list){
          res.tag_name_list.map((tag) => {
            convertedTag.push({id: tag, text: tag})
          })
        }

        this.setState({
          clientInfo: {
            ...this.state.clientInfo,
            first_name: res.first_name,
            last_name: res.last_name,
            gender: convertedGender,
            date_of_birth: res.birthday ? moment(res.birthday).format('YYYY-MM-DD') : '',
            mobile_parsed: res.mobile_parsed,
            email: res.email,
            guardian_name: res.guardian_name,
            guardian_email: res.guardian_email,
            remark: res.remark,
            tag_name_list: convertedTag,
          },
        }, () => {this.props.onFormChange(this.state.clientInfo)})
      })
    }

    if(this.props.clientList){
      let {clientList} = this.props
      let {tag_list} = clientList

      let newTagList = []
      tag_list.map((tag) => {
        newTagList.push({id: tag.name, text: tag.name})
      })

      this.setState({suggestions: newTagList})
    }
  }

  loadCustomFieldSchema() {
    const schoolId = localStorage.getItem('schoolId');
    getClientCustomFields(schoolId)
      .then((res)=>{
        if (res && res.contact_custom_fields) {
          const { fields } = res.contact_custom_fields;

          const customFieldSchema = [];

          fields.map((field, index) => {
            const {
              id,
              label,
              type,
              options,
              required,
            } = field

            if (typeof label === 'string' && label.length > 0) {
              switch (type) {
              case "text":
                customFieldSchema.push({name: id, label: label, type: 'text', required})
                break;
              case "select":
                let optionArr = options.map((option, i) => {
                  return {
                    value: option,
                    label: option,
                  }
                })

                // add an empty value in the beginning
                optionArr = [ {}, ...optionArr ];

                customFieldSchema.push({
                  name: id,
                  required,
                  label,
                  type: 'select',
                  options: optionArr,
                });

                break;
              case "checkbox":
                customFieldSchema.push({
                  name: id,
                  label:
                  label,
                  type: 'custom',
                  required,
                  component: (value, onChange, item, props)=>{
                    return <CheckboxForCustomField value={value} onChange={onChange} item={field} />
                  }
                })
                break;
              }
            }
          });

          this.setState({
            customFieldSchema,
          });

        }
    })
    .catch((err)=>{console.error(err)});
  }

  onChange(name) {
    let {onFormChange} = this.props;

    return (value) => {
      let newValue;

      if(name == 'date_of_birth'){
        newValue = moment(value).format('YYYY-MM-DD');
      } else if (name == 'gender') {
        newValue = value;
      } else if (name == 'guardian_name'){
        newValue = value;
      } else {
        newValue = value.target.value
      }

      this.setState({
        clientInfo: {
          ...this.state.clientInfo,
          [name]: newValue,
        }
      }, () => {
        onFormChange(this.state.clientInfo)
      })
    }
  }

  onNameChange({ firstName, lastName}) {
    this.setState({
      clientInfo: {
        ...this.state.clientInfo,
        'first_name': firstName,
        'last_name': lastName,
      }
    }, ()=>{
      this.props.onFormChange(this.state.clientInfo)
    });
  }

  onMobileChange(value){
    this.setState({
      clientInfo: {
        ...this.state.clientInfo,
        mobile_parsed: value
      }
    }, () => {
      this.props.onFormChange(this.state.clientInfo)
    })
  }

  handleDelete(i) {
    let {onFormChange} = this.props;
    const {clientInfo} = this.state
    const { tag_name_list } = clientInfo;
    this.setState({
      clientInfo: {
        ...this.state.clientInfo,
        tag_name_list: tag_name_list.filter((tag, index) => index !== i),
      }
    }, () => {
      onFormChange(this.state.clientInfo)
    });
  }

  handleAddition(tag) {
    let {onFormChange} = this.props;
    const {clientInfo} = this.state
    const { tag_name_list } = clientInfo;
    this.setState({
      clientInfo:{
        ...this.state.clientInfo,
        tag_name_list: [...tag_name_list, ...[tag]]
      }
    }, () => {
      onFormChange(this.state.clientInfo)
    });
  }

  handleInputFocus(){
    this.setState({showHint: true})
  }

  render(){
    let {clientInfo, suggestions, showHint, customFieldSchema} = this.state
    let {first_name, last_name, gender, date_of_birth, tag_name_list, mobile_parsed, guardian_name, remark} = clientInfo
    const {
      customFormData,
      onCustomDataChange,
      scrollingContainerRef,
      getCustomDataValidationRef
    } = this.props;

    return (
      <div className='potential-client-modal-content'>
        <div className='basic-info'>{__('Basic Information', locale)}</div>
        <div className='row'>
          <div className='col-xs-3 name-label'>
            {__('Name', locale)}
            <span className='c-red'>*</span>
          </div>
          <div className='col-xs-9'>
            <Name className='name' value={{firstName: first_name, lastName: last_name}} onChange={this.onNameChange} />
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-3 gender-label'>
            {__('Gender', locale)}
            <span className='c-red'>*</span>
          </div>
          <div className='col-xs-9'>
            <Gender className='gender' value={gender} onChange={this.onChange('gender')} />
          </div>
        </div>
        <div className='row DOB'>
          <div className='col-xs-3 DOB-label'>
            {__('Date of Birth', locale)}
          </div>
          <div className='col-xs-9'>
            <DOBPicker className='form-control' value={date_of_birth} onChange={this.onChange('date_of_birth')} />
          </div>
        </div>
        <div className='row contact-num'>
          <div className='col-xs-3 input-label'>
            {__('Contact Number', locale)}
            {/* <span className='c-red'>*</span> */}
          </div>
          <div className='col-xs-9'>
            <ReactPhoneInput className='form-control' defaultCountry={'ca'} value={mobile_parsed} onChange={this.onMobileChange} onlyCountries={['ca', 'us']} disableAreaCodes={true}/>
          </div>
        </div>
        <div className="row talk-bubble">
          <div className='col-xs-9'>
            <p className={showHint ? 'showHint' : 'noShow'}>{__("Please press 'Enter' to create a new tag", locale)}</p>
          </div>
        </div>
        <Tags
          tags={tag_name_list}
          label={__('Tag', locale)}
          tagContainerClass='form-control'
          className='potential-client-tags'
          placeholder={__('Add new tag for easier searching, ex: Language Class', locale)}
          suggestions={suggestions}
          handleDelete={this.handleDelete}
          handleAddition={this.handleAddition}
          handleInputFocus={this.handleInputFocus}
        />
        <div className='row'>
          <div className='col-xs-3 input-label'>{__('Parent Name', locale)}</div>
          <div className='col-xs-9'>
            <Input type='text' className='parent-name' value={guardian_name} onChange={this.onChange('guardian_name')} />
          </div>
        </div>
        <Remarks label={__('Remarks', locale)} inputClassName='form-control' rows={6} className='remarks' value={remark} onChange={this.onChange('remark')} />
        <div className='basic-info'>{__('Other Info', locale)}</div>
        <Form
          onChange={onCustomDataChange}
          schema={customFieldSchema}
          formData={customFormData}
          formStyle='inline'
          getValidationRef={getCustomDataValidationRef}
          scrollingContainerRef={scrollingContainerRef}
        />
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/PotentialClient/ModalContent.js